export function PriceSkeleton() {
  return <div className='h-6 w-[67px] rounded-md bg-gray-300 text-gray-300 animate-pulse' />;
}
